<template>
  <div>
    <div>
      <el-input v-model="search" placeholder="Buscar por título"/>
    </div>
    <br>
    <el-row>
      <el-col :md="16">
        <p>
          <b>{{currentRow.title? 'Procedimiento: '+currentRow.title : 'Seleccione procedimiento.'}}</b>
        </p>
      </el-col>
      <el-col :md="8" align="right">
        <el-button type="primary" @click="clear()" :disabled="!currentRow.id">
          <b>{{$t('Limpiar selección')}}</b>
        </el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="findProcedures"
      height="400"
      ref="singleTable"
      :data="procedures.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
      style="width: 100%; border: 10px; border-collapse: separate;"
      :row-class-name="() => 'rowClassTablaPlomaInventarioTarea'"
      header-cell-class-name="header-cell-class-table-gray">

      <el-table-column :label="$t('')" width="30px">
        <template slot-scope="scope">
          
            <el-checkbox size="small" :value="currentRowId === scope.row.id" @change="setCurrent(scope.row)"/>
          
        </template>
      </el-table-column>

      <el-table-column :label="$t('Código')" width="170px"><!-- align="center" -->
        <template slot-scope="scope">
          <div @click="setCurrent(scope.row)">{{scope.row.serial}}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Título')">
        <template slot-scope="scope">
          <div @click="setCurrent(scope.row)">{{scope.row.title}}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Ver')" width="50px" align="left">
        <template slot-scope="scope">
          <a :href="scope.row.pdf_document" target="_blank">
            <img class="img_pdf" src="@/assets/icons/text-documents_orange.svg"/>
          </a>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Quitar')" width="75px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            style="vertical-align: text-bottom;"
            :disabled="scope.row.is_deleted"
            @click="askForDeleteProcedure(scope.row)"
            icon="el-icon-delete"/>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <div>
      <el-button type="primary" @click="dialog = true" :disabled="findProcedures">
        <b>{{$t('Agregar Procedimiento')}}</b>
      </el-button>
    </div>

    <el-dialog
      width="500px"
      :appendToBody="true"
      :visible="dialog"
      :before-close="() => dialog = false">
      <UploadVendorProcedure :dialog.sync="dialog" :procedures="procedures"/>
    </el-dialog>

    <el-dialog
      width="400px"
      :appendToBody="true"
      :visible="askDeleteDialog"
      :before-close="() => askDeleteDialog = false">
      <div style="text-align:center">
        <h3>Quitar de la lista de procedimientos</h3>
        <p>¿Está seguro de quitar el procedimiento "{{selected.title}}" de la lista?</p>
      </div>
      <br>
      <div style="text-align:center">
        <el-button type="secondary" @click="askDeleteDialog = false">
          <b>{{$t('Cancelar')}}</b>
        </el-button>

        <el-button type="primary" @click="deleteProcedure">
          <b>{{$t('Eliminar')}}</b>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadVendorProcedure from "@/procedures/UploadVendorProcedure.vue";
import {
  getProcedures,
  addInventoryData,
  editInventoryData,
  editProcedure,
} from '@/procedures/requests.js';

export default {
  props: {
    selectedProcedures: {
      default: () => []
    },
    taskId: '',
    contractId: '',
    close: false,
  },
  components: { UploadVendorProcedure },
  data() {
    return {
      selected: {},
      dialog: false,
      askDeleteDialog: false,
      findProcedures: true,
      search: '',
      currentRowId: null,
      procedures: [],
    };
  },
  computed: {
    role() { return this.$store.getters.role },
    empresa_id() { return this.role.empresa_id; },
    currentRow() {
      if (!this.currentRowId) return {};
      return this.procedures.find(p => p.id === this.currentRowId) || {}
    },
    inventory_data() { // registro en la tabla de procedimiento que asocia proc standar con la tarea
      return this.selectedProcedures.find(f => f.task_id === this.taskId)
    }
  },
  watch: {
    close(val) {
      if (val === false) {
        if (! this.currentRowId) return;
        this.save();
      }
    },
    taskId(val) {
      this.currentRowId = null;
      if (this.inventory_data) this.currentRowId = this.inventory_data.procedure;
    }
  },
  created() {
    if (this.inventory_data) this.currentRowId = this.inventory_data.procedure;
    getProcedures({
      is_deleted: false,
      vendor_inventory_id: this.empresa_id,
    })
      .then(r => {
        this.findProcedures = false;
        if (r.length) this.procedures = r;
      })
      .catch(e => {
        console.error(e);
        this.findProcedures = false;
      });
  },
  methods: {
    askForDeleteProcedure(procedure) {
      this.selected = procedure
      this.askDeleteDialog = true;
    },
    deleteProcedure() {
      this.askDeleteDialog = false;
      this.selected.is_deleted = true;
      const proc = JSON.parse(JSON.stringify(this.selected));
	    delete proc.pdf_document;
      editProcedure(proc)
        .then(r => {
console.log({r})
          this.procedures.splice(this.procedures.indexOf(this.selected), 1);
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Procedimineto eliminado",
            type: "success"
          });
          
        })
        .catch(e => {
          console.error(e);
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Problema al eliminar",
            type: "error"
          });
        })
    },
    setCurrent(val) {
      this.currentRowId = this.currentRowId === val.id ? this.clear() : val.id;
    },
    clear() {
      this.currentRowId = null;
      if (this.inventory_data.id) this.save();
    },
    save() {
      const save = this.inventory_data || {task_id: this.taskId, inventory_id: this.contractId};

      const method = save.id ? editInventoryData : addInventoryData;

      save.procedure = this.currentRowId;

      method(save)
        .then(r => {
          if (r.id) {
            save.id
              ? save.id = r.id
              : this.selectedProcedures.push(r);
          } else {
            console.error(r)
          } // if
        })
        .catch(e => console.error(e));
    }
  },
};
</script>

<style scoped>
.img_pdf{
  height: 30px;
  margin-bottom: 5px;
}
</style>
